import React from 'react';

import { Col, Divider, Form, Row, Select } from 'antd';

/** BE `DisposalContractContributionType` değerleri; etiketler task metnindeki adlandırmadır. */
export const PAYMENT_TYPES = [
  { value: 'author', label: 'Yazar' },
  { value: 'supervisor', label: 'Madde Sorumlusu' },
  { value: 'committee_head', label: 'Heyet Başkanı' },
  { value: 'style_editor', label: 'Telif Sonrası' },
];

const PAYMENT_STATUS_OPTIONS = [
  { value: 'paid', label: 'Ödendi' },
  { value: 'unpaid', label: 'Ödenmedi' },
];

/**
 * Ödeme türü × ödeme durumu filtresi. Form değeri `paymentStatus: { <tip>: 'paid' | 'unpaid' }` olarak tutulur,
 * boş bırakılan tip filtreye girmez. BE filtresi yalnız admin ve sipariş birimi için çalışır.
 */
export const PaymentStatusFilter = () => (
  <>
    <Divider
      orientation="left"
      className="gx-mt-4 gx-mb-2"
    >
      Ödeme Durumu
    </Divider>
    <Row style={{ flexDirection: 'row', width: '100%' }}>
      {PAYMENT_TYPES.map(({ value, label }) => (
        <Col
          key={value}
          xs={24}
          sm={12}
          md={6}
          className="gx-mt-2"
        >
          <Form.Item
            label={label}
            name={['paymentStatus', value]}
          >
            <Select
              getPopupContainer={(triggerNode) => triggerNode.parentElement}
              placeholder="Seçiniz"
              options={PAYMENT_STATUS_OPTIONS}
              allowClear
            />
          </Form.Item>
        </Col>
      ))}
    </Row>
  </>
);
